import styled from "@emotion/styled";
import Tippy, { TippyProps } from "@tippyjs/react";
import { colors } from "@ui/style/colors";
import React from "react";
import "tippy.js/dist/tippy.css";

export const Tooltip = React.forwardRef<Element, TippyProps>((props, ref) => <StyledTippy ref={ref} {...props} />);
Tooltip.displayName = "Tooltip";

const StyledTippy = styled(Tippy)`
	padding: 8px;
	border-radius: 8px;
	background-color: ${colors.black};

	.tippy-arrow {
		color: ${colors.black};
	}
`;
